import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import DefaultOtherProfessionals from './DefaultOtherProfessionals';

const OtherProfessionalsPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return pickFunction(householdResource, {
    [fr.relationships.default.name]: () => {
      return (
        <DefaultOtherProfessionals {...props} />
      );
    },
  });
};

export default OtherProfessionalsPicker;
